module.exports = __webpack_public_path__ + "img/avatar80.ae870d6a.png";